import { PRODUCTION_API_DOMAIN, STAGING_API_DOMAIN, LOCAL_API_DOMAIN } from "lib/constants";

const ENV_HOSTS = {
  development: LOCAL_API_DOMAIN,
  production: PRODUCTION_API_DOMAIN,
  staging: STAGING_API_DOMAIN,
  test: LOCAL_API_DOMAIN,
};

export const getURLToFetch = (path: string) => {
  // in case NEXT_PUBLIC_DEPLOYED_ENV is not set, but it should be.
  const env = (process.env.NEXT_PUBLIC_DEPLOYED_ENV ?? process.env.NODE_ENV) as keyof typeof ENV_HOSTS;
  const host = ENV_HOSTS[env] ?? PRODUCTION_API_DOMAIN;

  return `${host}${path}`;
};
